import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px;
  .error {
    color: red;
  }
  .input {
    margin: 10px 0px;
  }
`;

export const StyledGrid = styled(Grid)`
  margin: 16px;
  .errorSelect {
    color: red;
  }
  .error {
    color: red;
  }
  .spaceBloc {
    margin-top: 15px;
  }
`;
